// app/redux/sagas/demandesSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    // types
    GET_MY_DEMANDES_REQUEST,
    GET_MY_FORMATION_DEMANDES_REQUEST,
    GET_CREATED_BY_ME_DEMANDES_REQUEST,
    GET_COMPANY_DEMANDES_REQUEST,

    CREATE_DEMANDE_COLLAB_REQUEST,
    CREATE_DEMANDE_MANAGER_REQUEST,
    CREATE_DEMANDE_RF_REQUEST,
    CREATE_EVENT_DEMANDE_BY_LEARNER_REQUEST,
    CREATE_EVENT_DEMANDE_BY_MANAGER_REQUEST,
    CREATE_EVENT_DEMANDE_BY_RF_REQUEST,
    CANCEL_EVENT_DEMANDE_REQUEST,
    WITHDRAW_EVENT_DEMANDE_REQUEST,

    CREATE_DEMANDE_MANAGER_BULK_REQUEST,
    CREATE_DEMANDE_RF_BULK_REQUEST,

    GET_DEMANDE_MANAGER_INBOX_REQUEST,
    GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST,
    GET_DEMANDE_RF_INBOX_REQUEST,
    GET_DEMANDES_CAMPAGNE_REQUEST,

    DEMANDE_MANAGER_DECISION_REQUEST,
    DEMANDE_RF_DECISION_REQUEST,

    // common
    setDemandeLoading,

    // list
    getMyDemandesSuccess,
    getMyDemandesFail,
    getMyFormationDemandesSuccess,
    getMyFormationDemandesFail,
    getCreatedByMeDemandesSuccess,
    getCreatedByMeDemandesFail,
    getDemandeTrackingSuccess,
    getDemandeTrackingFail,

    // create
    createDemandeCollabSuccess,
    createDemandeCollabFail,
    createDemandeManagerSuccess,
    createDemandeManagerFail,
    createDemandeRfSuccess,
    createDemandeRfFail,
    createEventDemandeByLearnerSuccess,
    createEventDemandeByLearnerFail,
    cancelEventDemandeSuccess,
    cancelEventDemandeFail,
    withdrawEventDemandeSuccess,
    withdrawEventDemandeFail,
    createEventDemandeByManagerSuccess,
    createEventDemandeByManagerFail,
    createEventDemandeByRfSuccess,
    createEventDemandeByRfFail,

    // bulk
    createDemandeManagerBulkSuccess,
    createDemandeManagerBulkFail,
    createDemandeRfBulkSuccess,
    createDemandeRfBulkFail,

    // inbox
    getDemandeManagerInboxSuccess,
    getDemandeManagerInboxFail,
    getDemandesManagerCampagneSuccess,
    getDemandesManagerCampagneFail,
    getDemandeRfInboxSuccess,
    getDemandeRfInboxFail,
    getDemandesCampagneSuccess,
    getDemandesCampagneFail,

    // decisions
    demandeManagerDecisionSuccess,
    demandeManagerDecisionFail,
    demandeRfDecisionSuccess,
    demandeRfDecisionFail, getCompanyDemandesFail, getCompanyDemandesSuccess, DOWNLOAD_PLAN_FORMATION_SUCCESS,
    DOWNLOAD_PLAN_FORMATION_FAIL, DOWNLOAD_BILAN_FORMATION_SUCCESS, DOWNLOAD_BILAN_FORMATION_FAIL,
    fetchParticipationCampagneSuccess,
    fetchParticipationCampagneFail,
    relanceWorkflowDemandeSuccess,
    relanceWorkflowDemandeFail,
    relanceWorkflowCampagneSuccess,
    relanceWorkflowCampagneFail,
    prolongerCampagneSuccess,
    prolongerCampagneFail,
    relanceParticipationCampagneSuccess,
    relanceParticipationCampagneFail, FETCH_PARTICIPATION_CAMPAGNE_REQUEST,
} from "../actions/demandesActions";
import {FETCH_CAMPAGNES_REQUEST, FETCH_VISIBLE_CAMPAGNES_REQUEST} from "../actions/campagnesActions";

import {API_BASE_URL, getBlobRequest, getRequest, postRequest} from "../../../api";
import {
    DOWNLOAD_DOMAINES_TEMPLATE_FAIL,
    DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS
} from "../actions/paramDomainesThemesActions";

const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;
    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);
    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

const buildEventDemandeSinglePayload = (payload) => ({
    type: "EVENT_SESSION",
    eventId: payload?.eventId,
    targetUserId: payload?.targetUserId,
    action: payload?.action || null,
    description: payload?.description || null,
});

const buildEventDemandeBulkPayload = (payload) => ({
    type: "EVENT_SESSION",
    eventId: payload?.eventId,
    items: (payload?.targetUserIds || []).map((targetUserId) => ({
        targetUserId: Number(targetUserId),
    })),
    action: payload?.action || null,
    description: payload?.description || null,
});

function* refreshConsolidationData(campagneId) {
    yield put({ type: FETCH_CAMPAGNES_REQUEST });
    yield put({ type: FETCH_VISIBLE_CAMPAGNES_REQUEST });
    yield put({ type: GET_COMPANY_DEMANDES_REQUEST });
    if (campagneId) {
        yield put({ type: FETCH_PARTICIPATION_CAMPAGNE_REQUEST, payload: { campagneId } });
    }
}

// ===================== WORKERS =====================

export function* getMyDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/my`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes");
        yield put(getMyDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getMyFormationDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/my/formations`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getMyFormationDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes de formation");
        yield put(getMyFormationDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getCreatedByMeDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/created-by-me`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCreatedByMeDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes (créées par moi)");
        yield put(getCreatedByMeDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getDemandeTrackingSaga(action) {
    const demandeId = action.payload?.demandeId;
    const url = `${API_BASE_URL}/api/demandes/${demandeId}/tracking`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandeTrackingSuccess(demandeId, resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement suivi demande");
        yield put(getDemandeTrackingFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- CREATE (3 modes) ----

export function* createDemandeCollabSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/collaborateur`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeCollabSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande envoyée avec succès",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_DEMANDES_REQUEST });
        yield put({ type: GET_MY_FORMATION_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande");
        yield put(createDemandeCollabFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeManagerSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/manager`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeManagerSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande créée (manager)",
            timer: 1600,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST }); // utile si "Les deux" ou "Responsable de formation"
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande manager");
        yield put(createDemandeManagerFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeRfSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/rf`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeRfSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande créée ",
            timer: 1600,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur création demande");
        yield put(createDemandeRfFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createEventDemandeByLearnerSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/collaborateur`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: buildEventDemandeSinglePayload(action.payload),
            headers: { uid },
        });
        yield put(createEventDemandeByLearnerSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande d'inscription envoyee",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_MY_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur creation demande evenement");
        yield put(createEventDemandeByLearnerFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* cancelEventDemandeSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const demandeId = action.payload?.demandeId;
    const url = `${API_BASE_URL}/api/demandes/${demandeId}/cancel`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {
                motif: action.payload?.motif,
                comment: action.payload?.comment || "",
            },
            headers: { uid },
        });

        yield put(cancelEventDemandeSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demande annulée avec succès.",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_DEMANDES_REQUEST });
        yield put({ type: GET_MY_FORMATION_DEMANDES_REQUEST });
        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur annulation demande");
        yield put(cancelEventDemandeFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* withdrawEventDemandeSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const demandeId = action.payload?.demandeId;
    const url = `${API_BASE_URL}/api/demandes/${demandeId}/withdraw`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: {
                motif: action.payload?.motif,
                comment: action.payload?.comment || "",
            },
            headers: { uid },
        });

        yield put(withdrawEventDemandeSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Désistement enregistré",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_MY_DEMANDES_REQUEST });
        yield put({ type: GET_MY_FORMATION_DEMANDES_REQUEST });
        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur demande desistement");
        yield put(withdrawEventDemandeFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createEventDemandeByManagerSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const targetUserIds = action.payload?.targetUserIds || [];
    const isBulk = targetUserIds.length > 1;
    const url = `${API_BASE_URL}/api/demandes/${isBulk ? "manager/bulk" : "manager"}`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: isBulk
                ? buildEventDemandeBulkPayload(action.payload)
                : buildEventDemandeSinglePayload({
                    ...action.payload,
                    targetUserId: targetUserIds[0],
                }),
            headers: { uid },
        });
        yield put(createEventDemandeByManagerSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes d'inscription envoyées",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
        yield put({ type: GET_COMPANY_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur creation demande evenement manager");
        yield put(createEventDemandeByManagerFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createEventDemandeByRfSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");
    const targetUserIds = action.payload?.targetUserIds || [];
    const isBulk = targetUserIds.length > 1;
    const url = `${API_BASE_URL}/api/demandes/${isBulk ? "rf/bulk" : "rf"}`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            token,
            data: isBulk
                ? buildEventDemandeBulkPayload(action.payload)
                : buildEventDemandeSinglePayload({
                    ...action.payload,
                    targetUserId: targetUserIds[0],
                }),
            headers: { uid },
        });
        yield put(createEventDemandeByRfSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes d'inscription envoyées",
            timer: 1800,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur creation demande evenement RF");
        yield put(createEventDemandeByRfFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2400,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- BULK ----

export function* createDemandeManagerBulkSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/manager/bulk`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeManagerBulkSuccess(resp.data || []));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes envoyées",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
        yield put({ type: GET_COMPANY_DEMANDES_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de création des demandes");
        yield put(createDemandeManagerBulkFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* createDemandeRfBulkSaga(action) {
    const url = `${API_BASE_URL}/api/demandes/rf/bulk`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: action.payload, headers: { uid } });
        yield put(createDemandeRfBulkSuccess(resp.data || []));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Demandes envoyées",
            timer: 1700,
            showConfirmButton: false,
        });

        yield put({ type: GET_CREATED_BY_ME_DEMANDES_REQUEST });
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur lors de création des demandes");
        yield put(createDemandeRfBulkFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- INBOX ----

export function* getDemandeManagerInboxSaga() {
    const url = `${API_BASE_URL}/api/demandes/inbox/manager`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandeManagerInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox manager");
        yield put(getDemandeManagerInboxFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getDemandesManagerCampagneSaga(action) {
    const { managerId, campaignId } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/manager/${managerId}/campagne/${campaignId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandesManagerCampagneSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes manager par campagne");
        yield put(getDemandesManagerCampagneFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getDemandeRfInboxSaga() {
    const url = `${API_BASE_URL}/api/demandes/inbox/rf`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandeRfInboxSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement inbox RF");
        yield put(getDemandeRfInboxFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getDemandesCampagneSaga(action) {
    const { campaignId } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/campagne/${campaignId}`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getDemandesCampagneSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes de la campagne");
        yield put(getDemandesCampagneFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

// ---- DECISIONS ----

export function* demandeManagerDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/${id}/manager-decision`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(demandeManagerDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision manager envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        if (action.payload?.managerId && action.payload?.campaignId) {
            yield put({
                type: GET_DEMANDES_MANAGER_CAMPAGNE_REQUEST,
                payload: {
                    managerId: action.payload.managerId,
                    campaignId: action.payload.campaignId,
                },
            });
        } else {
            yield put({ type: GET_DEMANDE_MANAGER_INBOX_REQUEST });
        }
        yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST }); // si "Les deux" -> passe chez RF
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision manager");
        yield put(demandeManagerDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* demandeRfDecisionSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    const { id, approved, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/demandes/${id}/rf-decision`;

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { approved, comment }, headers: { uid } });
        yield put(demandeRfDecisionSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Décision responsable formation envoyée",
            timer: 1400,
            showConfirmButton: false,
        });

        if (action.payload?.campaignId) {
            yield put({
                type: GET_DEMANDES_CAMPAGNE_REQUEST,
                payload: { campaignId: action.payload.campaignId },
            });
        } else {
            yield put({ type: GET_DEMANDE_RF_INBOX_REQUEST });
        }
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur décision responsable formation");
        yield put(demandeRfDecisionFail(msg));

        yield call([Swal, Swal.fire], {
            icon: "error",
            title: "",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* getCompanyDemandesSaga() {
    const url = `${API_BASE_URL}/api/demandes/company`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(getCompanyDemandesSuccess(resp.data || []));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement demandes société");
        yield put(getCompanyDemandesFail(msg));
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* fetchParticipationCampagneSaga(action) {
    const campagneId = action.payload?.campagneId;
    const url = `${API_BASE_URL}/api/demandes/consolidation/campagne/${campagneId}/participation`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const resp = yield call(getRequest, { url, token, headers: { uid } });
        yield put(fetchParticipationCampagneSuccess(campagneId, resp.data));
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur chargement participation campagne");
        yield put(fetchParticipationCampagneFail(msg));
    }
}

export function* relanceWorkflowDemandeSaga(action) {
    const demandeId = action.payload?.demandeId;
    const url = `${API_BASE_URL}/api/demandes/${demandeId}/relance-workflow`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: {}, headers: { uid } });
        yield put(relanceWorkflowDemandeSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Relance envoyée avec succés.",
            timer: 1800,
            showConfirmButton: false,
        });
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur relance demande");
        yield put(relanceWorkflowDemandeFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2400, showConfirmButton: false });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* relanceWorkflowCampagneSaga(action) {
    const campagneId = action.payload?.campagneId;
    const url = `${API_BASE_URL}/api/demandes/consolidation/campagne/${campagneId}/relance-workflow`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: {}, headers: { uid } });
        yield put(relanceWorkflowCampagneSuccess(resp.data));
        if (typeof action.payload?.onSuccess === "function") {
            yield call(action.payload.onSuccess, resp.data);
        }
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: resp.data?.message || `${resp.data?.relancedCount ?? 0} relance(s) envoyée(s).`,
            timer: 2200,
            showConfirmButton: false,
        });
        yield* refreshConsolidationData(campagneId);
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur relance workflow campagne");
        yield put(relanceWorkflowCampagneFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2600, showConfirmButton: false });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* prolongerCampagneSaga(action) {
    const { campagneId, newEndDate, comment } = action.payload || {};
    const url = `${API_BASE_URL}/api/campagnes/${campagneId}/prolonger`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: { newEndDate, comment }, headers: { uid } });
        yield put(prolongerCampagneSuccess(resp.data));
        if (typeof action.payload?.onSuccess === "function") {
            yield call(action.payload.onSuccess, resp.data);
        }
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: "Campagne prolongée avec succés. Les personnes concernées ont été notifiées.",
            timer: 2400,
            showConfirmButton: false,
        });
        yield* refreshConsolidationData(campagneId);
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur prolongation campagne");
        yield put(prolongerCampagneFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2600, showConfirmButton: false });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

export function* relanceParticipationCampagneSaga(action) {
    const campagneId = action.payload?.campagneId;
    const url = `${API_BASE_URL}/api/demandes/consolidation/campagne/${campagneId}/relance-participation`;
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    yield put(setDemandeLoading(true));
    try {
        const resp = yield call(postRequest, { url, token, data: {}, headers: { uid } });
        yield put(relanceParticipationCampagneSuccess(resp.data));
        if (typeof action.payload?.onSuccess === "function") {
            yield call(action.payload.onSuccess, resp.data);
        }
        yield call([Swal, Swal.fire], {
            icon: "success",
            title: "",
            text: `Relance envoyée à ${resp.data?.relancedCount ?? 0} personne(s).`,
            timer: 2200,
            showConfirmButton: false,
        });
        yield* refreshConsolidationData(campagneId);
    } catch (error) {
        const msg = extractErrorMessage(error, "Erreur relance participation");
        yield put(relanceParticipationCampagneFail(msg));
        yield call([Swal, Swal.fire], { icon: "error", title: "", text: msg, timer: 2600, showConfirmButton: false });
    } finally {
        yield put(setDemandeLoading(false));
    }
}

function downloadBlobAsFile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
}

export function* downloadGeneratePlanFormationExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/demandes/excel/bilan/formation/${action.cid}`;



        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "Plan_formation.xlsx");
        yield put({ type: DOWNLOAD_PLAN_FORMATION_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_PLAN_FORMATION_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template domaines échoué" });
    }
}


export function* downloadGenerateBilanCampagneExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid = sessionStorage.getItem("uid");

    try {
        const url = `${API_BASE_URL}/api/demandes/excel/bilan/${action.cid}`;



        const res = yield call(getBlobRequest, {
            url,
            token,
            extraHeaders: {
                uid,
                "X-Tenant-Id": sessionStorage.getItem('selectedCompanyId'),
            },
        });

        downloadBlobAsFile(new Blob([res.data]), "Bilan_Formation.xlsx");
        yield put({ type: DOWNLOAD_BILAN_FORMATION_SUCCESS });
    } catch (e) {
        yield put({
            type: DOWNLOAD_BILAN_FORMATION_FAIL,
            payload: e.response?.data || e.message,
        });

        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template domaines échoué" });
    }
}


// ===================== WATCHERS =====================
